<div id="advance-sales">
  <!-- Request Info -->
  <div *ngIf="sellerRunningAdvancedSales?.id">
    <div class="card">
      <div class="card-header">{{ 'Sellers.AdvanceSales.RequestInfo' | translate }}</div>
      <div class="card-body">
        <div class="row mx-0">
          <div class="col-md-6 p-3">
            <div class="row mx-0">
              <button class="btn btn-danger col-6">{{ 'Sellers.AdvanceSales.StartDate' | translate }}</button>
              <div class="btn col-6 border border-danger">
                {{sellerRunningAdvancedSales.startDate}}
              </div>
            </div>
          </div>
          <div class="col-md-6 p-3">
            <div class="row mx-0">
              <button class="btn btn-primary col-6">{{ 'Sellers.AdvanceSales.TotalAmount' | translate }}</button>
              <div class="btn col-6 border border-primary">
                {{sellerRunningAdvancedSales.totalAmount}}
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-0 justify-content-center">
          <div class="col-md-6 p-3">
            <div class="row mx-0">
              <button class="btn btn-warning balance-button col-6">{{ 'Sellers.AdvanceSales.PaidAmount' | translate }}</button>
              <div class="btn col-6 border border-warning">
                {{sellerRunningAdvancedSales.paidAmount}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Advance Your Sales -->
  <div class="row">
    <div class="col-sm-12 col-md-7 align-items-center justify-content-center d-flex flex-column animated zoomIn">
      <h3>{{ 'Sellers.AdvanceSales.AdvanceYourSales' | translate }}</h3>
      <p class="description">
        {{ 'Sellers.AdvanceSales.AdvanceDescription01' | translate }}
        <span class="fs-4 fw-bold text-success">{{ 'Sellers.AdvanceSales.AdvanceDescription02' | translate }}</span>
        {{ 'Sellers.AdvanceSales.AdvanceDescription03' | translate }}
      </p>
    </div>
    <div class="col-sm-12 col-md-5 d-flex justify-content-end animated zoomIn px-0">
      <img src="../../../../assets/images/background/advance.jpg" class="w-100" alt="">
    </div>
  </div>

  <!-- How it works -->
  <div class="row mb-5">
    <div class="col-12 align-items-center justify-content-center d-flex flex-column animated zoomIn">
      <h3>
        {{ 'Sellers.AdvanceSales.HowItWorks' | translate }}
      </h3>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-1 p-3 pe-5">
            <h4>{{ 'Sellers.AdvanceSales.ApplyPayment' | translate }}</h4>
            <p class="my-auto pe-5">
              {{ 'Sellers.AdvanceSales.ApplyPaymentDescription' | translate }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-2 p-3 pe-5">
            <h4>{{ 'Sellers.AdvanceSales.GetPayment' | translate }}</h4>
            <p class="my-auto pe-5">
              {{ 'Sellers.AdvanceSales.GetPaymentDescription' | translate }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-3 p-3 pe-5">
            <h4>{{ 'Sellers.AdvanceSales.RepayPace' | translate }}</h4>
            <p class="my-auto pe-5">
              {{ 'Sellers.AdvanceSales.RepayPaceDescription' | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Apply now ! -->
  <div class="row">
    <div class="col-12 align-items-center justify-content-center d-flex flex-column">
      <h3>{{ 'Sellers.AdvanceSales.ApplyNow' | translate }}</h3>
      <p>{{ 'Sellers.AdvanceSales.DragSlider' | translate }}</p>
      <form [formGroup]="sliderForm" (submit)="onSubmit()">
        <div class="row">
          <div class="col-12 align-items-center justify-content-center d-flex flex-column">
            <h1 class="fw-bold text-center">{{selectedRam}},000</h1>
            <div class="text-center mb-3" *ngIf="selectedFees !=0">
              {{ 'Sellers.AdvanceSales.Fees' | translate }} = {{selectedFees}} {{ 'Sellers.AdvanceSales.Monthly' | translate }} <br>
              {{ 'Sellers.AdvanceSales.FeesDescription' | translate }}
            </div>
            <input #ramSelector name="ram" formControlName="advancesaleslimit" class="form-control" type="range" min="0"
                   max="{{ramMaxValue == 0 ? 30 : ramMaxValue}}" (change)="setRam($event)">
          </div>
        </div>
        <div class="row mt-4">
          <div class="notes-container">
            <a class="card1">
              <p class="my-auto notes">{{ 'Sellers.AdvanceSales.Transaction' | translate }}</p>
              <div class="go-corner">
                <div class="go-arrow">
                  1
                </div>
              </div>
            </a>
            <a class="card1">
              <p class="my-auto notes">{{ 'Sellers.AdvanceSales.Terms' | translate }}</p>
              <div class="go-corner">
                <div class="go-arrow">
                  2
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div class="col-auto">
            <button class="btn btn-primary" type="submit" [disabled]="selectedFees == 0">
              {{ 'Sellers.AdvanceSales.RequestSale' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

